import React, { useEffect, useRef, useState } from "react";
import MonthYearPicker from "../../../components/common/ui/Inputs/MonthYearPicker";
import Button from "../../../components/common/ui/Button";
import { SelectInput } from "../../../components/common/ui/Inputs";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import Table from "../../../components/common/table/Table";
import MultiSelectDropdown from "../../../components/common/ui/Inputs/MultiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { masterActions } from "../../../_store/master.slice";
import { format } from "date-fns";
import { reportActions } from "../../../_store/reports.slice";
import CustomLoader from "../../../components/common/ui/Loader";
import { exportExcel } from "../../../utils/exportExcel";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import membershipReport from "../../../components/common/export/MembershipReportPDF";

function MembershipReport() {
  const dispatch = useDispatch();
  const ignoreSelectChange = useRef(false);
  const { getCommitteeListResponse, loading } = useSelector(
    (state) => state.master,
  );
  const { membershipReportList, loading: reportLoading } = useSelector(
    (state) => state.report,
  );

  const [filters, setFilters] = useState({
    fromDate: format(new Date(2014, 0), "yyyy-MM"),
    toDate: format(new Date(), "yyyy-MM"), // current month
    committees: [],
    isExport: false,
  });
  const [apiParams, setApiParams] = useState(`?page=${1}&limit=${10}`);
  console.log("apiParams", apiParams);
  console.log("filters", filters);
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);
  const [excelBtnDisabled, setExcelBtnDisabled] = useState(false);
  const [pdfBtnDisabled, setpdfBtnDisabled] = useState(false);

  useEffect(() => {
    dispatch(masterActions?.getCommitteeList());
  }, [dispatch]);

  useEffect(() => {
    const query = new URLSearchParams({
      page: "1",
      limit: "10",
    }).toString();

    setApiParams(`?${query}`);
  }, []);

  const columns = [
    {
      name: "Month & Year",
      key: "monthYear",
      selector: (row) => row.monthYear,
      sortable: true,
    },
    {
      name: "Committee Name",
      key: "committeeName",
      selector: (row) => row.committeeName,
      sortable: true,
    },
    {
      name: "Old Membership Count",
      key: "prevCount",
      selector: (row) => row.prevCount,
      sortable: true,
    },

    {
      name: "#Increase",
      key: "newCount",
      selector: (row) => row.newCount,
      sortable: true,
    },

    {
      name: "Current Membership Count",
      key: "newTotal",
      selector: (row) => row.newTotal,
      sortable: true,
    },

    {
      name: "%Increase",
      key: "percentageIncrease",
      sortable: true,

      selector: (row) => row?.percentageIncrease?.countInPercentage ?? 0,

      format: (row) => {
        const perc = row?.percentageIncrease?.countInPercentage;

        if (perc === undefined) return "-";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span>{perc}%</span>
            {/* {row.percentageIncrease.increased ? (
              <img height="20" width="20" src={Increase} alt="increase" />
            ) : (
              <img height="20" width="20" src={Decrease} alt="decrease" />
            )} */}
          </div>
        );
      },
    },
  ];

  const handleRowPerPage = (page) => {
    ignoreSelectChange.current = true;
    const updatedParams = apiParams.replace(/&limit=\d+/, `&limit=${page}`);
    setApiParams(updatedParams);
    dispatch(
      reportActions.getMembershipReport({
        params: updatedParams,
        payload: filters,
      }),
    )
      .then((result) => {
        if (result?.payload?.data) {
          ignoreSelectChange.current = false;
        }
      })
      .catch((err) => {
        console.log(err?.message);
      });
    setRowCountPerPage(page);
    setPageNo(1);
  };

  const handlePageChange = (page) => {
    ignoreSelectChange.current = true;
    const updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);
    setApiParams(updatedParams);
    dispatch(
      reportActions.getMembershipReport({
        params: updatedParams,
        payload: filters,
      }),
    )
      .then((result) => {
        if (result?.payload?.data) {
          ignoreSelectChange.current = false;
        }
      })
      .catch((err) => {
        console.log(err?.message);
      });
    setPageNo(page);
  };

  const handleDateChange = (name, value) => {
    let updated = { ...filters, [name]: value };
    if (updated.fromDate && updated.toDate) {
      const from = new Date(updated.fromDate + "-01");
      const to = new Date(updated.toDate + "-01");
      if (from > to) {
        if (name === "fromDate") updated.toDate = updated.fromDate;
        else updated.fromDate = updated.toDate;
      }
    }
    setFilters(updated);
  };

  const handleSelectChange = (selectedOptions, fieldName) => {
    // if (ignoreSubmit.current) return;
    if (ignoreSelectChange.current) return;
    const selectedIds = selectedOptions?.map((item) => item.value) || [];
    // setSelectedCommitteeList(selectedIds);
    setFilters((prevForm) => ({
      ...prevForm,
      [fieldName]: selectedIds,
    }));
  };

  const handleExcelExport = () => {
    ignoreSelectChange.current = true;
    setExcelBtnDisabled(true);
    const updateParams = { ...filters, isExport: true };
    setFilters(updateParams);
    dispatch(
      reportActions.getMembershipReport({
        params: apiParams,
        payload: updateParams,
      }),
    )
      .then((res) => {
        const updateParams = { ...filters, isExport: false };
        setFilters(updateParams);
        if (res?.payload?.data) {
          ignoreSelectChange.current = false;
        }
        setExcelBtnDisabled(false);
        const formattedData = res?.payload?.data?.results?.map((item) => ({
          "Month & Year": item.monthYear,
          "Committee Name": item.committeeName,
          "Old Membership Count": item.prevCount,
          "#Increase": item.newCount,
          "Current Membership Count": item.newTotal,
          "%Increase": item.percentageIncrease?.countInPercentage + "%",
        }));
        const now = new Date();

        const formattedDate =
          now.getFullYear() +
          "" +
          String(now.getMonth() + 1).padStart(2, "0") +
          "" +
          String(now.getDate()).padStart(2, "0");

        const formattedTime =
          String(now.getHours()).padStart(2, "0") +
          "" +
          String(now.getMinutes()).padStart(2, "0") +
          "" +
          String(now.getSeconds()).padStart(2, "0");

        const safeTitle = "Membership-report".replace(/[^a-z0-9]/gi, "_");
        const fileName = `${safeTitle}_${formattedDate}_${formattedTime}.xlsx`;
        exportExcel(formattedData, fileName, "Membership report status");
      })
      .catch((err) => {
        setExcelBtnDisabled(false);
        showToastNotification("Failed to export data", "error");
      });
  };

  const handlePDFExport = () => {
    ignoreSelectChange.current = true;
    let title = "Membership Report";
    setpdfBtnDisabled(true);
    const updateParams = { ...filters, isExport: true };
    setFilters(updateParams);
    dispatch(
      reportActions.getMembershipReport({
        params: apiParams,
        payload: updateParams,
      }),
    )
      .then((res) => {
        const updateParams = { ...filters, isExport: false };
        setFilters(updateParams);
        if (res?.payload?.data) {
          ignoreSelectChange.current = false;
        }
        setpdfBtnDisabled(false);

        const formattedData = res?.payload?.data?.results?.map((item) => ({
          monthYear: item.monthYear,
          committeeName: item.committeeName,
          oldTotal: item.prevCount,
          increaseCount: item.newCount,
          newTotal: item.newTotal,
          increasePercentage: item.percentageIncrease?.countInPercentage,
        }));
        membershipReport(formattedData, false, title);
      })
      .catch((err) => {
        console.log(err?.message);
        setpdfBtnDisabled(false);
        showToastNotification("Failed to export data", "error");
      });
  };

  const handleSearch = (e) => {
    e?.preventDefault();
    ignoreSelectChange.current = true;
    dispatch(
      reportActions.getMembershipReport({
        params: apiParams,
        payload: filters,
      }),
    )
      .then((result) => {
        if (result?.payload?.data) {
          ignoreSelectChange.current = false;
        }
      })
      .catch((err) => {
        console.log(err?.message);
      });
  };

  // const handleReset = (e) => {
  //   e?.preventDefault();
  //   dispatch(reportActions?.resetMembershipReport());
  //   setApiParams(`?page=${1}&limit=${10}`);
  //   setFilters({
  //     ...filters,
  //     fromDate: format(new Date(2014, 0), "yyyy-MM"),
  //     toDate: format(new Date(), "yyyy-MM"),
  //     committees: [],
  //   });
  // };

  const handleReset = (e) => {
    e?.preventDefault();

    dispatch(reportActions?.resetMembershipReport());

    setApiParams(`?page=1&limit=10`);
    setPageNo(1);
    setRowCountPerPage(10);

    setFilters({
      fromDate: format(new Date(2014, 0), "yyyy-MM"),
      toDate: format(new Date(), "yyyy-MM"),
      committees: [],
      isExport: false,
    });
  };
  const toLocalMonthStart = (yyyyMm) => {
    const [year, month] = yyyyMm.split("-").map(Number);
    return new Date(year, month - 1, 1);
  };

  if (reportLoading || loading) return <CustomLoader />;
  return (
    <div className="flex justify-end mb-1 p-4">
      <h1 className="header-color">Membership Report</h1>
      <form className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100 p-3">
        <div className="row">
          <div className="col-md-4">
            <MonthYearPicker
              name="fromDate"
              label="From Date"
              value={filters.fromDate}
              handleChange={(val) => handleDateChange("fromDate", val)}
              minDate={new Date("2014-01-01")}
              // maxDate={new Date(filters.toDate + "-01")}
              maxDate={toLocalMonthStart(filters.toDate)}
            />
          </div>

          <div className="col-md-4">
            <MonthYearPicker
              name="toDate"
              label="To Date"
              value={filters.toDate}
              handleChange={(val) => handleDateChange("toDate", val)}
              // minDate={new Date(filters.fromDate + "-01")}
              minDate={toLocalMonthStart(filters.fromDate)}
              maxDate={new Date()}
            />
          </div>

          <div className="col-md-4">
            <MultiSelectDropdown
              name="committees"
              options={getCommitteeListResponse?.data}
              displayValue="label"
              handleChange={(e) => handleSelectChange(e, "committees")}
              placeholder="Choose Committee"
              required
              label="Committee"
              sortType="alphabetical"
              selectedValue={
                Array.isArray(getCommitteeListResponse?.data) &&
                Array.isArray(filters?.committees)
                  ? getCommitteeListResponse.data.filter((option) =>
                      filters.committees.includes(option.value),
                    )
                  : []
              }
            />
          </div>
        </div>
        <div className="row mt-3 d-flex justify-content-center">
          <div className="col-md-2 d-flex align-items-end h-100 mt-2 mt-lg-0 gap-2">
            <Button
              status="secondary"
              label="Search"
              type="button"
              disabled={filters?.committees?.length === 0}
              onClick={(e) => {
                handleSearch(e);
              }}
            />
            <Button
              status="reset"
              label="Reset"
              type="reset"
              // disabled={filters?.committees?.length === 0}
              onClick={(e) => {
                handleReset(e);
              }}
            />
          </div>
        </div>
      </form>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <div className="d-flex justify-content-between align-items-center p-3 flex-wrap">
          <h1 className="m-0 search-header-color">Membership Report List</h1>
          {membershipReportList?.data?.results?.length > 0 && (
            <div className="d-flex gap-3">
              <button
                className="btn btn-success btn-sm d-flex align-items-center gap-1"
                onClick={() => {
                  handleExcelExport();
                }}
                disabled={excelBtnDisabled}
              >
                <FaFileExcel size={14} />
                <span>Export to Excel</span>
              </button>
              <button
                className="btn btn-danger btn-sm d-flex align-items-center gap-1"
                onClick={() => {
                  handlePDFExport();
                }}
                disabled={pdfBtnDisabled}
              >
                <FaFilePdf size={14} />
                <span>Export to PDF</span>
              </button>
            </div>
          )}
        </div>
        <Table
          columns={columns}
          data={membershipReportList?.data?.results}
          pagination
          onChangeRowsPerPage={handleRowPerPage}
          onChangePage={handlePageChange}
          totalRowCount={membershipReportList?.data?.totalItems}
          currentPage={pageNo}
          paginationPerPage={rowCountPerPage}
        />
      </div>
    </div>
  );
}

export default MembershipReport;
